import * as React from 'react';
var RatioContext = /*#__PURE__*/React.createContext(1);
RatioContext.displayName = 'RatioContext';
export var RatioConsumer = RatioContext.Consumer;
export var RatioProvider = RatioContext.Provider;
export default RatioContext;